import I18n from 'I18n';
import { CollapsiblePanel } from './CollapsiblePanel';
import { InboxNavPanelBody } from './InboxNavPanelBody';
import { usePortalData } from '../data/usePortalData';
import { useResolvedTicketListings } from '../data/useResolvedTicketListings';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { jsx as _jsx } from "react/jsx-runtime";
const INBOX_NAV_POLL_INTERVAL = 5 * 60 * 1000;
export function InboxNavPanel() {
  var _portalData$settings;
  const {
    data: portalData
  } = usePortalData();
  const {
    ticketView,
    statusFilter,
    searchString,
    sort,
    offset,
    setOffset,
    createDateFilter,
    lastActivityFilter,
    hasActiveFilters
  } = useTicketListingsSortAndFilters();
  const ticketListings = useResolvedTicketListings({
    offset,
    pollInterval: INBOX_NAV_POLL_INTERVAL,
    ticketView,
    statusFilter,
    searchString,
    sort,
    createDateFilter,
    lastActivityFilter
  });
  const title = (portalData === null || portalData === void 0 || (_portalData$settings = portalData.settings) === null || _portalData$settings === void 0 ? void 0 : _portalData$settings.ticketLabelOverride) || I18n.text('customer-portal-app.inboxNavPanel.title');
  return /*#__PURE__*/_jsx(CollapsiblePanel, {
    mode: "sidebar",
    side: "left",
    borderSide: "end",
    expandAriaLabel: I18n.text('customer-portal-app.inboxNavPanel.expand'),
    collapseAriaLabel: I18n.text('customer-portal-app.inboxNavPanel.collapse'),
    title: title,
    flushBody: true,
    children: /*#__PURE__*/_jsx(InboxNavPanelBody, {
      tickets: ticketListings.data,
      loading: ticketListings.loading,
      total: ticketListings.total,
      offset: offset,
      setOffset: setOffset,
      error: !!ticketListings.error,
      hasActiveFilters: hasActiveFilters
    })
  });
}